// @flow
import type {PaymentDetailDTO, Creditor} from '../definitions/swagger'
import {createFetchClientWithAuth} from '../util/request/middleware'
import {camelCase as camelCaseObject, changeKeys as changeKeysObject} from 'change-case-object'
import moment from 'moment'

const client = createFetchClientWithAuth('v1/budget')


/**
 *  Records that a client is aware of a late payment
 * @link http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Budget/Budget_UpdatePaymentAwareness
 * @param expenseId
 * @return {Promise.<string>}
 */
export async function updatePaymentAwareness(expenseId : string) : Promise<string>{
	return (await client.post(`expenses/${expenseId}/updatePaymentAwareness/`)).ClientNotificationId
}

/**
 * Updates a payment
 * @link http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Payment/Payment_UpdatePayment
 * @param paymentId
 * @param streamId
 * @param amount
 * @param dateExpected
 * @param detail
 * @return {Promise.<string>}
 */
export async function updatePayment(paymentId : string, streamId: string, amount : string, dateExpected : string, detail : PaymentDetailDTO = {} ): Promise<string>{
	const result = await client.post(`payment/${paymentId}/update`, {
		body: {
			StreamId: streamId,
			Amount: amount,
			DueDate: moment(dateExpected).format('YYYY-MM-DD[T]HH:mm:ss'),
			Detail: changeKeysObject((key) => key === 'bsb' ? 'BSB' : key.charAt(0).toUpperCase() + key.slice(1), detail)
		}
	})

	return result.ClientNotificationId
}

export async function getCreditors() : Promise<Array<Creditor>>{
	return camelCaseObject(await client.get('creditors'))
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/payment.js